(function () {
    'use strict';

    angular
        .module('app')
        .controller('userThemeList', ['$scope', 'plmThemes', function ($scope, plmThemes) {
            var themeId = $scope.item.Theme == null ? 0 : $scope.item.Theme;
            var themeName = plmThemes.getThemes()[themeId].name;
            $scope.item.themeStyle = themeName;
        }])
        .controller('UserListController', lController);

    function lController($scope, $http, $cookies, $location, $rootScope, $timeout, $interval, $state, UserService, RoleService, BrandService, toaster) {
        var model = this;
        model.Users = [];

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] == 6) {
                if (userPermissionRow[1] == 1) {
                    model.UserRead = true;
                }
                if (userPermissionRow[1] == 2) {
                    model.UserEdit = true;
                }
                if (userPermissionRow[1] == 3) {
                    model.UserCreate = true;
                }
            }
        });

        if (!model.UserRead) {
            $state.go('permissionDenied');
        }

        model.UsersPredicate = ""; model.UsersReverse = false;
        model.UsersTableOrderby = function (predicate) {
            model.UsersReverse = model.UsersPredicate == predicate ? !model.UsersReverse : false;
            model.UsersPredicate = predicate;
        }

        function getBrands() {
            BrandService.getBrands().then(function (response) {
                if (response) {
                    model.brands = response;
                }
                else {
                    model.showError('No roles found');
                }

            },
            function (error, status) {
                model.showError('There was an error while retrieving brand data. Please contact system administrator');
            });
        };

        function getRoles() {
            RoleService.getAllRoles().then(function (response) {
                if (response) {
                    //model.isErrorRole = false;
                    model.roles = response;
                }
                else {
                    model.showError('There was an error while retrieving role data. Please contact system administrator');
                }

            },
            function (error, status) {
                model.showError('There was an error while retrieving role data. Please contact system administrator');
            });
        };

        function getUsers() {
            model.loadingUsers = true;
            var brandId = 0;
            var roleId = 0;

            if (model.selectedBrand && model.selectedBrand.BrandId) {
                brandId = model.selectedBrand.BrandId;
            }
            if (model.selectedRole && model.selectedRole.RoleId) {
                roleId = model.selectedRole.RoleId;
            }

            UserService.getUsers(brandId, roleId).then(function (response) {
                if (response) {
                    model.Users = response;
                    model.loadingUsers = false;
                }
                else {
                    model.Users = "";
                    model.loadingUsers = false;
                }

            },
            function (error, status) {
                model.loadingUsers = false;
                model.Users = "";
                model.showError('There was an error while getting users. Please contact system administrator');
            });
        };

        model.roleSelected = function () {
            getUsers();
        };
        model.brandSelected = function () {
            getUsers();
        };

        getBrands();
        getRoles();
        getUsers();

        model.showError = function (msg) {
            toaster.pop({ type: 'error', title: 'Error!', body: msg, timeout: 5000 });
        };

        model.showSuccess = function (msg) {
            toaster.pop({ type: 'success', title: 'Success!', body: msg, timeout: 5000 });
        };

    }
})();


